export const ARRAY_LIST_FAVORITES_FILTERED_ADVISER_FORM = 'ARRAY_LIST_FAVORITES_FILTERED_ADVISER_FORM'
export const IS_OPEN_CUSTOMER_MODAL_FILTERED_ADVISER_FORM = 'IS_OPEN_CUSTOMER_MODAL_FILTERED_ADVISER_FORM'
export const IS_LOADING_FAVORITES_FILTER_ADVISER_FORM = 'IS_LOADING_FAVORITES_FILTER_ADVISER_FORM'
export const FORM_DATA_FILTERED_ADVISER_FORM = 'FORM_DATA_FILTERED_ADVISER_FORM'
